export default __webpack_public_path__ + "594dce115710525d7771ebe3ab82db19.png";